import { ReactComponent } from "./checked-box.svg";

interface Props {
  fill?: string;
  width?: number;
  height?: number;
}

const CheckedBoxIcon: React.FC<Props> = ({ fill, width, height }) => (
  <ReactComponent fill={fill} width={width} height={height} />
);

export default CheckedBoxIcon;
